import React from 'react';
import { WorksList } from './WorksList';

export const Portfolio = () => {
  // 

  
 return (
    <div className="page">
      <h1 className="page-title">Portafolio</h1>
      <WorksList/>
    </div>
  )
}
